import { useEffect, useState } from "react";

export default function Preloader() {
  const [leaving, setLeaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const startLeave = setTimeout(() => setLeaving(true), 1900);
    const unmount = setTimeout(() => setDone(true), 2650);
    return () => {
      clearTimeout(startLeave);
      clearTimeout(unmount);
    };
  }, []);

  if (done) return null;

  return (
    <div
      className={`grain fixed inset-0 z-[100] flex items-center justify-center bg-foreground-950 transition-opacity duration-700 ${
        leaving ? "pointer-events-none opacity-0" : "opacity-100"
      }`}
      aria-hidden={leaving}
    >
      <div className="flex flex-col items-center px-6">
        {/* Ícone de play com anéis pulsantes */}
        <div className="relative mb-9 flex h-24 w-24 items-center justify-center">
          <span className="absolute inset-0 rounded-full border-2 border-primary-500/40 animate-loader-ring" />
          <span className="absolute -inset-3 rounded-full border border-primary-500/15" />
          <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-500 text-foreground-950 animate-pulse-soft">
            <i className="ri-play-fill text-4xl" aria-hidden="true" />
          </span>
        </div>

        {/* Wordmark */}
        <h1 className="font-heading text-2xl font-bold tracking-[0.18em] text-foreground-50">
          PLAY<span className="text-primary-500">MENU</span>
        </h1>
        <p className="mt-3 text-sm text-foreground-400">
          O cardápio que desperta desejo
        </p>

        {/* Barra de progresso */}
        <div className="mt-8 h-[3px] w-44 overflow-hidden rounded-full bg-foreground-800">
          <div className="h-full w-full animate-loader-bar bg-primary-500" />
        </div>
      </div>
    </div>
  );
}